import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { InputSelector } from "../../components/Forms/InputSelector";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { useNavigate, useParams } from "react-router";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel, userAtom } from "../../atoms";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import BaseForm from "../../components/Forms/BaseForm";
import { useSearchParams } from "react-router-dom";
import { useSetChangesMade } from "../../components/Publishing/utils";
import {
  screenTypes,
  validateFields,
} from "../../utils/slideTemplateAllocation";
import SlidesForm from "./form";
import { PreviewSelector } from "./previews";

const CreateSlides = (): JSX.Element => {
  const [originFrom, originId] = useOriginParams();
  const [searchParams] = useSearchParams();
  const screenId = _.toNumber(searchParams.get("screenType") || -1);
  const screenType = screenTypes[screenId as keyof typeof screenTypes];

  const userData = useAtomValue(userAtom);
  const modelData = useAtomValue(modelDataAtom);
  const modelName = "slides";
  const setChangesMade = useSetChangesMade(modelName);

  const capitalizedName = screenType ? `${screenType?.name} slide` : "-";

  const navigate = useNavigate();
  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoading) {
      const [emptyData, getSchema] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );

      const dataWithParams = getSchema.reduce((obj, item) => {
        const key = item.name;
        const checkValue = searchParams.get(key);
        if (searchParams.get(key))
          return {
            ...obj,
            [key]: checkValue,
          };
        return obj;
      }, {});

      const originValues =
        originFrom && originId
          ? {
              [`owner${originFrom}Id`]: parseInt(originId || "-1"),
            }
          : {};

      setItemData({
        ...emptyData,
        ...dataWithParams,
        ...originValues,
        screenType: screenId,
      });
      setSchema(getSchema);
      setIsLoading(false);
    }
    if (!screenType) navigate("/m/error");
  }, [modelData]);

  const saveItem = async () => {
    try {
      // const validate = validateFields(screenId, itemData);
      // if (!validate.valid) {
      //   tMsg.error(validate.message);
      //   return;
      // }

      const getCurrent = await apiAgent.DataType.getAll(modelName);

      // console.log("this is the itemdata before creation", itemData);
      const response = await apiAgent.DataType.create(modelName, {
        ...itemData,
        editedBy: userData?.id,
        sortId: getCurrent?.data?.length || 1,
      });

      if (response.status === 200) {
        // console.log("response from create endpoint", response.data);
        tMsg.success(`Slide successfully created`);
        setChangesMade();
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}?screenType=${screenId}`);
        else if (response?.data?.newId)
          navigate(
            `/m/${modelName}/show/${response.data.newId}?screenType=${screenId}`
          );
        else navigate(`/m/${modelName}?screenType=${screenId}`);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error creating ${capitalizedName}`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: `${screenType?.name}`,
      link: `/m/${modelName}?screenType=${screenId}`,
    },
  ];

  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Create ${capitalizedName}`}>
          <BackButton />
        </TitleBar>
        <SlidesForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem();
          }}
        />
        <PreviewSelector screenType={screenId} itemData={itemData} />
      </PageContent>
      <PageFooterBar>
        <SaveButton />
      </PageFooterBar>
    </PageContainer>
  );
};

export default CreateSlides;
